// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-user--image-button {\n  color: var(--primary);\n  border: 1px solid var(--gray-500);\n  margin-bottom: 20px; }\n  .form-user--image-button .container-icon-button svg {\n    color: var(--primary); }\n", ""]);
// Exports
module.exports = exports;
